import gql from 'graphql-tag';

import type { User } from 'src/data/user';
import { executeGqlQuery, type GqlQueryOptions } from 'src/graphql/client';
import { CUSTOMER_FRAGMENT } from 'src/graphql/customer';
import { FRAGMENT_AB_TEST } from 'src/graphql/schema';
import { getSingleProp } from 'src/lib/graphql';

import {
  FRAGMENT_BOOKMARK,
  FRAGMENT_ONBOARDING_STAGE,
  FRAGMENT_USER_SETTINGS,
  USER_FRAGMENT,
} from './schema';

const QUERY = gql`
  query CurrentUser {
    me {
      ...User
      isConfirmed
      isKeywee
      isExpert
      hasExternalApiAccess
      createdAt
      featureFlags
      companyInformation
      segment
      homePagePersona

      accounts {
        edges {
          role
          isInvited
          node {
            ...Customer
          }
        }
      }

      onboardingStages {
        ...UserOnboardingStage
      }

      abTests {
        ...AbTest
      }

      bookmarks {
        ...Bookmark
      }

      settings {
        ...UserSettings
      }
    }
  }
  ${USER_FRAGMENT}
  ${CUSTOMER_FRAGMENT}
  ${FRAGMENT_ONBOARDING_STAGE}
  ${FRAGMENT_AB_TEST}
  ${FRAGMENT_BOOKMARK}
  ${FRAGMENT_USER_SETTINGS}
`;

type Result = User;

export const queryCurrentUser = async (options?: GqlQueryOptions) => {
  const result = await executeGqlQuery({ query: QUERY, options });
  return getSingleProp<Result>(result.data);
};
